import styled from 'styled-components'
import { Dialog } from '@material-ui/core'

const StyledModalDialog = styled(Dialog)`
  && {
    .MuiDialog-paper {
      width: 600px;
      max-width: 90vw;
      height: auto;

      @media screen and (max-width: ${(p) => p.theme.sizes.phone}) {
        height: 90vh;
        overflow-y: auto;
      }
    }
  }
`

export default StyledModalDialog
